const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/equities/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '6',
    positionsUrl: 'equity-positions',
    transactionsUrl: 'equity-transactions',
    valueMovementUrl: 'equity-value-movement',
  });

  const service = serviceFactory({
    api,
  });

  return routeAdderFactory({ assetType: 'equities', service });
}

module.exports = addRoutes;
